import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PermitDetail } from '../../../models/permit-detail.model';

/**
 * Renders the right per-type detail view for a permit, switching on its
 * discriminator. Used by both the CRM detail page and the public magic-link
 * view, so the type-specific rendering lives in one place.
 */
@Component({
    selector: 'app-permit-detail',
    templateUrl: './permit-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PermitDetailComponent {
    @Input() permit!: PermitDetail;
    /** Staff-only: allow per-clan-area approve/reject on fishing & hunting permits. */
    @Input() canDecide = false;
    /** Bubbles up when a clan-area decision is saved, so the host page can reload. */
    @Output() decided = new EventEmitter<void>();
}
